//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getBillRuleSelector } from '@/api/system/billRule';
export default {
  name: 'billRule',
  props: ['value', 'disabled', 'placeholder'],
  model: {
    prop: 'value',
    event: 'change'
  },
  data: function data() {
    return {
      options: [],
      innerValue: this.value
    };
  },
  methods: {
    getData: function getData() {
      var _this = this;
      getBillRuleSelector().then(function (res) {
        _this.options = res.data.list;
      });
    }
  },
  created: function created() {
    this.getData();
  },
  watch: {
    innerValue: function innerValue(val) {
      val && this.$emit('change', val);
    },
    value: function value(val) {
      this.innerValue = val;
    }
  }
};